import { createSelector } from '@reduxjs/toolkit';
import {
  ELIGIBILITY_CHECK_SLICE_NAME,
  EligibilityCheckState,
} from './eligibility-check.types';

export const selectEligibilityCheckState = (state: { [x: string]: any }) =>
  state[ELIGIBILITY_CHECK_SLICE_NAME];

export const selectBigN = createSelector(
  selectEligibilityCheckState,
  (eligibilityCheckState: EligibilityCheckState) =>
    eligibilityCheckState?.memberBigN,
);
